import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Stethoscope, GraduationCap, Award, Eye, ShieldCheck, Sparkles } from 'lucide-react';
const audiences = [{
  icon: Stethoscope,
  title: 'Estudiantes en internado',
  desc: 'Estás en guardia y necesitás respuestas rápidas, no libros de 800 páginas.',
  image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?auto=format&fit=crop&w=400&q=80'
}, {
  icon: GraduationCap,
  title: '5to y 6to año',
  desc: 'Ya rotás por clínica y querés entender lo que ves, no solo copiarlo.',
  image: 'https://images.unsplash.com/photo-1532938911079-1b06ac7ceec7?auto=format&fit=crop&w=400&q=80'
}, {
  icon: Award,
  title: 'Previo a residencia',
  desc: 'Querés diferenciarte y demostrar razonamiento clínico desde el día uno.',
  image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=400&q=80'
}, {
  icon: Eye,
  title: 'Aprendizaje visual',
  desc: 'Aprendés mejor con esquemas, algoritmos y casos que con texto denso.',
  image: 'https://images.unsplash.com/photo-1581595220892-b0739db3ba8c?auto=format&fit=crop&w=400&q=80'
}];
export function TargetAudience() {
  return <section className="py-16 px-4 bg-medical-blue text-white relative overflow-hidden" data-id="element-330">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-331">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/dot-grid.png')]" data-id="element-332"></div>
      </div>

      <div className="max-w-5xl mx-auto relative" data-id="element-333">
        <div className="text-center mb-12" data-id="element-334">
          <div className="inline-flex items-center gap-2 bg-accent-gold text-medical-blue font-bold px-4 py-1.5 rounded-full text-xs mb-4 tracking-widest" data-id="element-335">
            <Sparkles size={14} data-id="element-336" />
            ¿PARA QUIÉN ES?
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold mb-4" data-id="element-337">
            Diseñado para vos
          </h2>
          <p className="text-lg md:text-xl text-blue-200 font-medium max-w-2xl mx-auto" data-id="element-338">
            Si querés entrar a guardia con otra cabeza
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10" data-id="element-339">
          {audiences.map((item, i) => {
          const Icon = item.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            delay: i * 0.1
          }} className="bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/20 hover:bg-white/15 transition-colors" data-id="element-340">
                <div className="relative h-32 overflow-hidden" data-id="element-341">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover" loading="lazy" data-id="element-342" />
                  <div className="absolute inset-0 bg-gradient-to-t from-medical-blue via-medical-blue/50 to-transparent" data-id="element-343"></div>
                  <div className="absolute bottom-3 left-3 bg-white text-medical-blue w-10 h-10 rounded-xl flex items-center justify-center shadow-lg" data-id="element-344">
                    <Icon size={20} data-id="element-345" />
                  </div>
                </div>
                <div className="p-4" data-id="element-346">
                  <h3 className="font-bold text-base mb-2 leading-tight" data-id="element-347">
                    {item.title}
                  </h3>
                  <p className="text-xs text-blue-100 leading-relaxed" data-id="element-348">
                    {item.desc}
                  </p>
                </div>
              </motion.div>;
        })}
        </div>

        <div className="flex justify-center" data-id="element-349">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-3 bg-success-green text-white px-5 py-3 rounded-full font-bold shadow-2xl text-sm md:text-base" data-id="element-350">
            <ShieldCheck size={20} data-id="element-351" />
            <span data-id="element-352">¿No estás seguro? Tenés 7 días de garantía</span>
          </motion.div>
        </div>
      </div>
    </section>;
}